import { loadingAsyncState } from "widgets-for-react";
import { fetchEmbed } from "./ThemakiezerBlockApi";
export const initialThemakiezerBlockState = (props)=>({
        books: loadingAsyncState(fetchEmbed(props.embedId))
    });
